import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import ReactDOM from 'react-dom';
import cls from 'classnames';
import Image from 'next/image';

import styles from './style.module.scss';

export interface ToastProps {
  duration?: number;
  showIcon?: boolean;
  className?: string;
  content?: React.ReactNode | string;
  onClose?: void;
  icon?: string;
  onExited?(): void;
}

const DEFAULT_DURATION = 3000;

const ToastComponent = (props: Omit<ToastProps, 'onClose'>) => {
  const { showIcon = false, icon = '', className, content, onExited, duration = DEFAULT_DURATION } = props;
  const [inProp, setInProp] = useState(false);

  useEffect(() => {
    setInProp(true);
    const timer = setTimeout(() => {
      setInProp(false);
    }, duration);
    return () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      timer && clearTimeout(timer);
    };
  }, [duration]);

  return ReactDOM.createPortal(
    <CSSTransition
      timeout={600}
      in={inProp}
      onExited={onExited}
      classNames={{
        enter: styles.toastEnter,
        enterActive: styles.toastEnterActive,
        enterDone: styles.toastEnterDone,
        exit: styles.toastEnter,
        exitActive: styles.toastExit,
      }}
    >
      <div className={styles.toast}>
        <div className={cls(styles.toastContainer, styles[`toast-container-simple`], className)}>
          {showIcon && (
            <div className={styles.toastIcon}>
              <Image quality={100} src={icon} />
            </div>
          )}
          <div className={styles.toastWrapper}>{content}</div>
        </div>
      </div>
    </CSSTransition>,
    document?.body,
  );
};

const Toast = (props: ToastProps) => {
  const div = document?.createElement('div');
  ReactDOM.render(<ToastComponent {...props} onExited={() => ReactDOM.unmountComponentAtNode(div)} />, div);

  return {
    destory(): void {
      ReactDOM.unmountComponentAtNode(div);
    },
  };
};

const showToast = (content: ToastProps['content'], props?: Omit<ToastProps, 'content'>) => Toast({ content, ...props });

export default {
  showToast,
};
